import styled from 'styled-components'
import { AlignType, MarginType, PaddingType } from 'common/types/styleTypes'
import {
  mobilePaddingsCss,
  paddingsCss,
  textCss,
  mobileTextCss,
  marginCss,
  mobileMarginCss,
} from 'common/utils/styleUtilsNew'

export interface BaseSearchResultsUiStylesInterface {
  fontSize: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  fontFamily?: string
  fontWeight?: string
  fontStyle?: string
  mobileFontFamily?: string
  mobileFontWeight?: string
  mobileFontStyle?: string
  letterSpacing?: number
  mobileLetterSpacing?: number
  textAlign: AlignType
  mobileTextAlign?: AlignType
  color: string
  mobileColor?: string
  margin?: Partial<MarginType>
  mobileMargin?: Partial<MarginType>
}

export const SearchResultsCardsWrapperUi = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
`

interface SearchResultsWrapperUiStylesInterface {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
}
export const SearchResultsWrapperUi = styled.div<SearchResultsWrapperUiStylesInterface>`
  ${paddingsCss};
  ${p => p.theme.isEditorMobileMode && mobilePaddingsCss}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }
`

export const SearchResultsTotalTitleUi = styled.span<BaseSearchResultsUiStylesInterface>`
  width: 100%;
  display: inline-block;
  ${textCss};
  ${marginCss};
  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.isEditorMobileMode && mobileMarginCss}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`
